export * from './IconIpadStroked';
